import { ButtonType } from './Button.constants'

export function hasButtonIcon(iconProps) {
  return Object.keys(iconProps).length > 0 && iconProps.Icon
}

export function isButtonSubmitType(type) {
  return type === ButtonType.Submit
}
